import React, { useEffect, useState } from "react";
import "./VerifyUser.css"; // Import the CSS file
import { Link, useNavigate, useParams } from "react-router-dom";
import {
  useAddLoginMutation,
  useAddUserVerifyMutation,
} from "../../../../Services/userApi";
import { Notification } from "../../../../components/ToastNotification";
import { savedLocalStorage } from "../../../../utils/function/localStorage";
export let popupShow = false;
const VerifyUserForm = () => {
  const { token } = useParams();

  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);
  const [formData, setFormData] = useState({
    username: "",
    password: "",
    rememberMe: false,
  });

  const [
    addVerifyUser,
    { data: verifiedData, isLoading: verifiedLoading, error: verifiedError },
  ] = useAddUserVerifyMutation();
  // console.log({ verifiedData });
  // console.log({ verifiedLoading });
  // console.log({ verifiedError });
  useEffect(() => {
    if (verifiedData?.message) {
      Notification(verifiedData?.message, "success");
      savedLocalStorage("grow_boo_token", token);
      navigate("/dashboard");
    } else {
      Notification(verifiedError?.data?.message, "error");
    }
  }, [verifiedError, verifiedData]);

  useEffect(() => {
    console.log({ token });
    const verified = async () => {
      await addVerifyUser(token);
    };
    verified();
  }, [addVerifyUser, token]);

  // add user
  const [addLogin, { error, data, isLoading }] = useAddLoginMutation();
  useEffect(() => {
    if (data?.message) {
      Notification(data?.message, "success");
      popupShow = true;
      navigate("/dashboard");
      // popupShow = true;
      savedLocalStorage("grow_boo_token", data?.token);
      // removeLocalStorage("otp_timer");
    } else {
      Notification(error?.data?.message, "error");
      // refresh();
    }
  }, [error, data, navigate]);

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log("Login data:", formData);
    const logData = {
      password: formData.password,
      userId: formData.username,
    };
    console.log("Prepared login data:", logData);
    await addLogin(logData);
    // Add your login logic here
  };

  return (
    <div className="login-wrapper">
      <div className="login-container">
        {/* Header Section */}
        <div className="login-header">
          <div className="title-row">
            <h1>Login To</h1>
            <h1 className="verify-brand-highlight">
              Grow Bizint International
            </h1>
          </div>
          <p>Your smart money journey continues here.</p>
        </div>

        {/* Form Section */}
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="username">Username or Email</label>
            <input
              type="text"
              id="username"
              name="username"
              value={formData.username}
              onChange={handleChange}
              className="form-control"
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="password">Password</label>
            <div className="password-wrapper">
              <input
                type={showPassword ? "text" : "password"}
                id="password"
                name="password"
                value={formData.password}
                onChange={handleChange}
                className="form-control"
                required
              />
              {/* Eye Icon Toggle */}
              <button
                type="button"
                className="toggle-password"
                onClick={togglePasswordVisibility}
                aria-label="Toggle password visibility"
              >
                {showPassword ? "👁️" : "👁️‍🗨️"}
              </button>
            </div>
          </div>

          <div className="checkbox-group">
            <input
              type="checkbox"
              id="rememberMe"
              name="rememberMe"
              checked={formData.rememberMe}
              onChange={handleChange}
            />
            <label htmlFor="rememberMe">Remember me</label>
          </div>

          <div className="form-actions">
            <button
              type="submit"
              className="auth-btn-login"
              disabled={isLoading}
            >
              {isLoading ? "Loading..." : "Login"}
            </button>

            <div className="links">
              <span>Need an account?</span>
              <Link to="/join-us">Register</Link>
              <Link to="/forgot-password">Forgot password?</Link>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default VerifyUserForm;
